import { useClientConfigProvider } from "@/app/config/client-config-provider";
import AppRoutes from "@/app/constants/routes";
import { useRouter } from "next/navigation";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Trans } from "react-i18next";

const CustomFooter = ({
  checked = false,
  setChecked,
}: {
  checked: boolean;
  setChecked: Function;
}) => {
  const { getImagePath } = useClientConfigProvider();
  const router = useRouter();

  return (
    <div className="footer-v2 ">
      <div className="accept-tnc-container secondary">
        {/* <input
              type="checkbox"
              name="tnc"
              className="checkbox"
              onChange={(e) => {
                e.target.checked && bookingForm.setFieldValue("tnc", true);
                !e.target.checked && bookingForm.setFieldValue("tnc", false);
              }}
            /> */}

        <Image
          className="c-pointer termscondition-checkbox"
          id="terms&condition"
          alt=""
          src={getImagePath(
            !checked ? "checkbox1.svg" : "checked-checkbox1.svg"
          )}
          width={18}
          height={18}
          onClick={(e: any) => {
            setChecked(!checked);
            // e.target.checked && bookingForm.setFieldValue("tnc", true);
            // !e.target.checked && bookingForm.setFieldValue("tnc", false);
          }}
        />
        <span>
          <Trans
            i18nKey="loginterms.accept_terms_policy"
            components={{
              loginterms: (
                <Link
                  href={AppRoutes.termAndCondition}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <u />
                </Link>
              ),
              privacy: (
                <Link
                  href={AppRoutes.privacyAndPolicy}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <u />
                </Link>
              ),
            }}
          />
        </span>
        {/* 
        <span>
          I have read and accept the{" "}
          <Link
            href={AppRoutes.termAndCondition}
            target="_blank"
            rel="noopener noreferrer"
          >
            <u>Terms of Service</u>
          </Link>{" "}
          and{" "}
          <Link
            href={AppRoutes.privacyAndPolicy}
            target="_blank"
            rel="noopener noreferrer"
          >
            <u>Privacy Policy</u>
          </Link>{" "}
        </span> */}
      </div>
      {/* <p>
        I have read and accept the{" "}
        <a href={`\ ${AppRoutes.termAndCondition}`}>Terms of Service</a> and{" "}
        <a href={`\ ${AppRoutes.privacyAndPolicy}`}>Privacy Policy</a>
      </p> */}
    </div>
  );
};

export default CustomFooter;
